module.exports = __webpack_public_path__ + "static/media/296137.af752f41.jpg";